import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { NavLink } from 'react-router-dom';
import SearchBarContainer from '../../../components/SearchBar/SearchBarContainer';
import { ACCEPTED, SOLD, navigationMapping } from '../../../consts/navigation';
import { connect } from 'react-redux';
import { compose } from 'redux';
import withScopedTranslations from '../../../withScopedTranslations/withScopedTranslations';

const BreadcrumbsArchive = ({ onSearchClick, tableName, isMobile, t, }) => {
  return (
    <div className="main-area__header archive-breadcrumbs">
      { isMobile && <SearchBarContainer onSearchClick={onSearchClick} tableName={tableName} delay={600} /> }

      <div className="details__menu">
        <ul>
          <NavLink to={navigationMapping[ACCEPTED].table_url}>{t('accepted')}</NavLink>
          <NavLink to={navigationMapping[SOLD].table_url}>{t('sold')}</NavLink>
        </ul>
      </div>

      { !isMobile && <SearchBarContainer onSearchClick={onSearchClick} tableName={tableName} delay={600} /> }

      <style jsx="true">{`
        .archive-breadcrumbs {
          display: flex;
          justify-content: space-between;
        }
      `}</style>
    </div>
  );
};

BreadcrumbsArchive.propTypes = {
  onSearchClick: PropTypes.func.isRequired,
  isMobile: PropTypes.bool,
  t: PropTypes.func.isRequired,
  tableName: PropTypes.string.isRequired,
};
BreadcrumbsArchive.defaultProps = {
  isMobile: true,
}

const mapStateToProps = (state) => {
  return {
    isMobile: get(state, ['layout', 'isMobile']),
  };
};

export default compose(
  connect(mapStateToProps),
  withScopedTranslations('breadcrumbs.archive')
)(BreadcrumbsArchive);
